export default __webpack_public_path__ + "static/media/logo-green.f96312f4.png";